import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { buildCategoryCollection, getCategoryMeta } from '../../../utils/categoryCatalog';
import { readPersistedStores } from '../../../utils/storeSeed';

interface Store {
  id: string;
  name: string;
  logo: string;
  description: string;
  category: string;
  subcategory?: string;
  rating: number;
  isActive: boolean;
  createdAt: string;
  promos: StorePromo[];
}

interface StorePromo {
  id: string;
  code: string;
  discount: string;
  description: string;
  expiryDate: string;
  isActive: boolean;
  isTopDeal?: boolean;
  image?: string;
}

export default function Categories() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState<Array<{
    id: string;
    name: string;
    icon: string;
    color: string;
    promoCount: number;
  }>>([]);

  useEffect(() => {
    const stores = readPersistedStores(localStorage) as Store[];
    const categoriesArray = buildCategoryCollection(stores)
      .map((category) => {
        const meta = getCategoryMeta(category.name);

        return {
          id: category.id,
          name: category.name,
          icon: meta.icon,
          color: meta.color,
          promoCount: category.promosCount,
        };
      });

    setCategories(categoriesArray);
  }, []);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Категории промокодов</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Выберите интересующую категорию и найдите лучшие скидки и промокоды
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((category) => (
            <div
              key={category.id}
              onClick={() => navigate(`/category/${category.id}`)}
              className="bg-white border border-gray-200 rounded-xl p-6 text-center hover:shadow-lg transition-all duration-300 cursor-pointer group"
            >
              <div className={`w-16 h-16 ${category.color} rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${category.icon} text-2xl`}></i>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2 text-sm">{category.name}</h3>
              <p className="text-gray-500 text-xs">{category.promoCount} промокодов</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
